import { Api } from "./Api";

let HolidayApi = {
    endpoint: "Holidays/",
}

//Add the Api Mixin
HolidayApi = Object.assign({}, Api, HolidayApi);

export { HolidayApi };
